/** Build-time configuration. Everything comes from `VITE_*` variables (see `.env.example`). */

const read = (key: string): string | undefined => {
  const value = (import.meta.env as Record<string, string | undefined>)[key];
  return value && value.trim() !== '' ? value.trim() : undefined;
};

export const env = {
  /** Local development only: the API's `ENV=local` accepts `Bearer dev-token`. */
  devAuthToken: read('VITE_DEV_AUTH_TOKEN'),
  appVersion: read('VITE_APP_VERSION') ?? '0.1.0',
  envLabel: read('VITE_ENV_LABEL'),
  firebase: {
    apiKey: read('VITE_FIREBASE_API_KEY'),
    authDomain: read('VITE_FIREBASE_AUTH_DOMAIN'),
    projectId: read('VITE_FIREBASE_PROJECT_ID'),
    appId: read('VITE_FIREBASE_APP_ID'),
    /** Browser alerts (lib/push.ts): the project's sender id and its Web Push certificate key pair's public key. */
    messagingSenderId: read('VITE_FIREBASE_MESSAGING_SENDER_ID'),
    vapidKey: read('VITE_FIREBASE_VAPID_KEY'),
  },
} as const;

export const firebaseConfigured = Boolean(env.firebase.apiKey && env.firebase.appId);
/** Browser alerts need the sender id and VAPID key on top of sign-in's config. */
export const pushConfigured = firebaseConfigured && Boolean(env.firebase.messagingSenderId && env.firebase.vapidKey);
